import request from 'oc-request';

export default class Paginator {
  constructor(sComponentMethod = 'onGetJSONData') {
    this.sComponentMethod = sComponentMethod;
    this.obStoreList = null;
    this.obSuccessRequestCallback = null;
  }

  onGetJSONData(iPage = 1, iPerpage = 10) {
    request.sendData(this.sComponentMethod, {
        data: {
          store: {
            ...this.obStoreList
          },
          page: iPage,
          perpage: iPerpage,
        },
        success: (response) => {
          this.obSuccessRequestCallback(response);
        },
    });
  }

  setSuccessRequestCallback(obCallback) {
    this.obSuccessRequestCallback = obCallback;

    return this;
  }

  setStoreList(obData) {
    this.obStoreList = obData;

    return this;
  }
}